const INITIAL_STATE = {
    payrolls: []
};

const payrollReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'SET_PAYROLLS':
            return {
                ...state,
                payrolls: action.payload
            };
        default:
            return state;
    }
};

export default payrollReducer;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/reducers/payrollReducer.js